import date from './date'
import array from './array'
import image from './image'
import num from './numTool'
export default {date, array, image,num}
